
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkUserPublicJoblevelEnum } from '../models/work-user-public-joblevel-enum';

export function getUpdateUserDtoFormGroup() {
return new FormGroup({
    firstName: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    shortname: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    password: new FormControl<string | undefined>(undefined, [Validators.maxLength(255)]),
    email: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    emailprivate: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    mobileprivate: new FormControl<string | undefined>(undefined, [Validators.maxLength(20)]),
    birthdate: new FormControl<string | undefined>(undefined),
    street: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    city: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    entrydate: new FormControl<string | undefined>(undefined),
    emergencycontact: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    phone: new FormControl<string | undefined>(undefined, [Validators.maxLength(20)]),
    iaxuser: new FormControl<boolean | undefined>(undefined),
    remarks: new FormControl<string | undefined>(undefined),
    userImageId: new FormControl<number | undefined>(undefined),
    mailSignature: new FormControl<string | undefined>(undefined),
    mailSignatureImageId: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
    loginV4Possible: new FormControl<boolean | undefined>(undefined),
    abacusNumber: new FormControl<number | undefined>(undefined),
    maxObPerWeek: new FormControl<number | undefined>(undefined),
    showOnWebsite: new FormControl<boolean | undefined>(true),
    socialSecurityNumber: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    publicJoblevel: new FormControl<WorkUserPublicJoblevelEnum | undefined>(undefined),
    publicJobtitle: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    loginPossibleUntil: new FormControl<string | undefined>("2199-12-31"),
    loxonePin: new FormControl<string | undefined>(undefined),
    jobtitle: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    exitdate: new FormControl<string | undefined>(undefined),
    dataReviewed: new FormControl<string | undefined>(undefined),
})
;
}
      